var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg4085231933a)" },
      React.createElement("path", { d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z", fill: "#F0F0F0" }),
      React.createElement("path", { d: "M22.956 24H48c0-2.166-.289-4.265-.827-6.26H22.956V24zM22.956 11.478h21.521a24.125 24.125 0 0 0-5.537-6.26H22.957v6.26zM24 48c5.648 0 10.84-1.952 14.94-5.217H9.06A23.897 23.897 0 0 0 24 48zM3.523 36.522h40.954a23.856 23.856 0 0 0 2.696-6.261H.827a23.857 23.857 0 0 0 2.696 6.26z", fill: "#D80027" }),
      React.createElement("path", { d: "M11.117 3.748h2.187L11.27 5.226l.777 2.391-2.034-1.478-2.034 1.478.67-2.066a24.13 24.13 0 0 0-4.654 5.188h.7l-1.294.941a23.97 23.97 0 0 0-.581 1.026l.618 1.903-1.153-.838a23.76 23.76 0 0 0-.785 1.863l.681 2.097h2.515L2.66 19.208l.777 2.392-2.034-1.478-1.218.885C.064 21.987 0 22.987 0 24h24V0c-4.741 0-9.16 1.375-12.883 3.748zm.93 17.852l-2.034-1.478L7.979 21.6l.777-2.392-2.035-1.477h2.515l.777-2.392.777 2.392h2.514l-2.034 1.477.777 2.392zm-.777-9.383l.777 2.392-2.034-1.478-2.034 1.478.777-2.392L6.72 10.74h2.515l.777-2.391.777 2.391h2.514l-2.034 1.478zm9.386 9.383l-2.034-1.478-2.035 1.478.777-2.392-2.034-1.477h2.514l.777-2.392.777 2.392h2.515l-2.034 1.477.777 2.392zm-.777-9.383l.777 2.392-2.034-1.478-2.035 1.478.777-2.392-2.034-1.478h2.514l.777-2.391.777 2.391h2.515l-2.034 1.478zm0-6.991l.777 2.391-2.034-1.478-2.035 1.478.777-2.391-2.034-1.478h2.514l.777-2.392.777 2.392h2.515l-2.034 1.478z", fill: "#0052B4" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg4085231933a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h48v48H0z" })
      )
    )
  );
});